import { addDays, subDays } from 'date-fns';
import { useWashHubListener } from 'hooks';
import React, { useEffect, useState } from 'react';
import { washHub } from 'store';

import { InventoryCountProps } from './InventoryCount.props';

import useQueryParams from 'hooks/useQueryParams';
import useUrlSharing from 'hooks/useUrlSharing';

import InventoryCountView from './InventoryCount.view';

const InventoryCountContainer = (_: InventoryCountProps) => {
  const [endDate, setEndDate] = useState<Date>();
  const [startDate, setStartDate] = useState<Date>();
  const [status, setStatus] = useState<string>();
  const [site, setVenue] = useState<string[]>();
  const [urlRecord, setUrlRecord] = useState({});
  const [isUrlMapped, setIsUrlMapped] = useState<boolean>(false);
  const [defaultIndex, setDefaultIndex] = useState<number>(0);
  const [accountManagers, setAccountManagers] = useState<string[]>();

  const washHubId = washHub.selectors.useSelectedWashHubId();

  const queryUrl = useQueryParams();

  const isUpdated = useUrlSharing(urlRecord, washHubId);

  useEffect(() => {
    const urlParams = {
      washHubId: String(washHubId),
      ...(status ? { status } : {}),
      ...(defaultIndex ? { defaultIndex: `${defaultIndex}` } : {}),
      ...(accountManagers
        ? { accountManagers: accountManagers.join('-') }
        : {}),
      ...(startDate ? { startDate: `${startDate.valueOf()}` } : {}),
      ...(endDate ? { endDate: `${endDate.valueOf()}` } : {}),
      ...(site ? { site: site.join('-') } : {}),
    };
    setUrlRecord(urlParams);
  }, [
    washHubId,
    endDate,
    startDate,
    status,
    site,
    defaultIndex,
    accountManagers,
  ]);

  useEffect(() => {
    const {
      status,
      site,
      defaultIndex,
      startDate,
      endDate,
      accountManagers,
    } = queryUrl;
    status && setStatus(status);
    site && setVenue(site.split('-'));
    defaultIndex && setDefaultIndex(+defaultIndex || 0);
    startDate && setStartDate(new Date(+startDate));
    endDate && setEndDate(new Date(+endDate));
    accountManagers && setAccountManagers(accountManagers.split('-'));
    if (isUpdated) setIsUrlMapped(true);
  }, [isUpdated]);

  useWashHubListener(() => {
    setStartDate(undefined);
    setEndDate(undefined);
    setStatus(undefined);

    onClearFilters();
  });

  const onSearchPress = (startDate: Date | null, endDate: Date | null) => {
    if (startDate) {
      setStartDate(startDate);
    }

    if (endDate) {
      setEndDate(endDate);
    }

    setStatus(undefined);
  };

  const onSearchClear = () => {
    setStartDate(undefined);
    setEndDate(undefined);
    setStatus(undefined);
  };

  const onStatusClick = (_status?: string) => {
    setStatus(_status);

    const today = new Date();

    if (_status === 'overdue') {
      const yesterday = subDays(today, 1);

      setEndDate(yesterday);
      setStartDate(undefined);
    } else if (_status === 'today') {
      setEndDate(today);
      setStartDate(today);
    } else if (_status === 'tomorrow') {
      const tomorrow = addDays(today, 1);

      setEndDate(tomorrow);
      setStartDate(tomorrow);
    } else if (_status === 'future') {
      const tomorrow = addDays(today, 1);

      setEndDate(undefined);
      setStartDate(tomorrow);
    } else {
      setStartDate(undefined);
      setEndDate(undefined);
    }
  };

  const onApplyFilters = (data: any, type: string) => {
    if (type === 'accountManagers') {
      setAccountManagers(data);
      return;
    }

    // default to site filter
    setVenue(data);
  };

  const onClearFilters = () => {
    setVenue(undefined);
    setAccountManagers(undefined);
  };

  const _props = {
    status,
    site,
    startDate,
    endDate,
    washHubId,
    defaultIndex,
    accountManagers,
    setDefaultIndex,
    onSearchPress,
    onSearchClear,
    onStatusClick,
    onApplyFilters,
    onClearFilters,
  };

  if (!isUrlMapped) return null;
  return <InventoryCountView {..._props} />;
};

export default InventoryCountContainer;
